import { useState } from 'react';
import { Container, Row, Col, Card } from 'reactstrap';
import { Btn, Spinner } from 'AbstractElements';
import { useSelector } from 'react-redux';
import ToolLeadBox from './ToolLeadBox';
import ToolLeadFilter from './Filter/ToolLeadFilter';
import ModalExportToolLead from './ModalExportToolLead';

const ToolLeadsContain = () => {
	const isExport = useSelector((state) => state.ToolLead.isExport);
	const [exportOpen, setExportOpen] = useState(false);

	return (
		<Container fluid={true}>
			<Col md="12" className="project-list">
				<Card>
					<Row className="justify-content-end align-items-center mb-3">
						<Col className="d-flex justify-content-end">
							<Btn
								attrBtn={{
									color: 'warning',
									onClick: () => setExportOpen(true),
								}}
							>
								<i className="fa fa-download fa-lg"></i> Export Tool Leads
							</Btn>
						</Col>
					</Row>
				</Card>
			</Col>

			{isExport && (
				<Col lg="12 mb-5">
					<div className="loader-box">
						<Spinner attrSpinner={{ className: 'loader-30' }} />
					</div>
					<h6 className="sub-title mb-0 text-center">Exporting Data...</h6>
				</Col>
			)}

			<Row className="learning-block">
				<Col xl="9" className="xl-80">
					<Row>
						<ToolLeadBox />
					</Row>
				</Col>
				<ToolLeadFilter />
			</Row>

			<ModalExportToolLead
				isOpen={exportOpen}
				toggle={() => setExportOpen(false)}
			/>
		</Container>
	);
};

export default ToolLeadsContain;
